import { useLayoutEffect } from "react";
const canUseDOM = () => {
    return (typeof window !== "undefined" &&
        typeof window.document !== "undefined" &&
        typeof window.document.createElement !== "undefined");
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const useClientLayoutEffect = canUseDOM() ? useLayoutEffect : () => { };
